import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import WhyChooseSection from '../components/WhyChooseSection';
import FeaturesSection from '../components/FeaturesSection';
import EncryptedEmailSection from '../components/EncryptedEmailSection';
import Footer from '../components/Footer';
import ContactFormModal from '../components/ContactFormModal';

const HomePage = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white" data-testid="homepage">
      <Navbar onChatClick={() => setIsContactOpen(true)} />
      <HeroSection />
      <FeaturesSection />
      <EncryptedEmailSection />
      <WhyChooseSection />
      <Footer />
      <ContactFormModal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} />
    </div>
  );
};

export default HomePage;
